export default __webpack_public_path__ + "3146a485fbe85835a7ae8252501c0b2c.jpeg";